var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnalisis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.966 5.523c.217 0 .398.157.436.363l.007.08v11.495a.444.444 0 01-.363.436l-.08.007H1.368a.444.444 0 01-.436-.364l-.007-.08V5.967c0-.217.157-.398.364-.436l.08-.007h4.597zM13.287 3.224c.217 0 .398.157.436.364l.007.08V17.46a.444.444 0 01-.364.436l-.08.007H8.69a.444.444 0 01-.436-.364l-.007-.08V3.668c0-.217.156-.398.363-.436l.08-.007h4.598zM20.608.925c.217 0 .398.157.435.364l.008.08V17.46a.444.444 0 01-.364.436l-.08.007H16.01a.443.443 0 01-.435-.364l-.007-.08V1.369c0-.217.156-.398.363-.436l.08-.007h4.597zM20.974 20.19H.75v.991h20.224z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalisis);
export default __webpack_public_path__ + "static/media/icon_analisis.9cb44412d4374b5bbb0c58caa823a67c.svg";
export { ForwardRef as ReactComponent };